import {PlayerEnums} from '../GameEnums'
import PlayerConstants = PlayerEnums.PlayerConstants
import {isValueStringBetween} from '@colonist/validation'

export function isGuestUsernameLengthValid(text: string): boolean {
    return isValueStringBetween(text, PlayerConstants.MIN_USERNAME_LENGTH, PlayerConstants.MAX_GUEST_USERNAME_LENGTH)
}

export function isRegisteredUsernameLengthValid(text: string): boolean {
    return isValueStringBetween(text, PlayerConstants.MIN_USERNAME_LENGTH, PlayerConstants.MAX_USERNAME_LENGTH)
}
